module.exports = {"440983001":"东镇街道","440983101":"镇隆镇","440983102":"水口镇","440983105":"丁堡镇","440983106":"池洞镇","440983112":"贵子镇","440983113":"怀乡镇","440983114":"茶山镇","440983115":"洪冠镇","440983116":"白石镇","440983117":"大成镇","440983118":"钱排镇","440983119":"合水镇","440983120":"新宝镇","440983121":"平塘镇","440983122":"思贺镇","440983123":"金垌镇","440983124":"朱砂镇","440983125":"北界镇","440983400":"信宜市国营红旗农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440983.json
// module id = 2136
// module chunks = 0